import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class GetAllReports extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Report/GetAll");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetDailyReportOfOrders extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Report/GetDailyReportOfOrders");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

export { GetAllReports, GetDailyReportOfOrders };
